import { CUSTOM_FIELD_CATEGORIES } from "@/Features";
import CustomFieldsApi from "@/api/custom-fields/index";
import EvidenceTypesAPI from "@/api/evidence-types";

export interface CustomFieldAPIBundle {
  id: CUSTOM_FIELD_CATEGORIES;
  description: string;
  createField: typeof CustomFieldsApi.createCustomField;
  updateField: typeof CustomFieldsApi.updateCustomField;
  deleteField: typeof CustomFieldsApi.deleteCustomField;
  getFields: typeof CustomFieldsApi.getCustomFields;
  getTypes: typeof EvidenceTypesAPI.getEvidenceTypes | null;
}

const customFieldAPIBundler: CustomFieldAPIBundle[] = [
  {
    id: CUSTOM_FIELD_CATEGORIES.CASE,
    description:
      "Create custom fields for cases. These custom fields will appear when creating a new case and will also show as a column in the case grid.",
    createField: CustomFieldsApi.createCustomField,
    updateField: CustomFieldsApi.updateCustomField,
    deleteField: CustomFieldsApi.deleteCustomField,
    getFields: CustomFieldsApi.getCustomFields,
    getTypes: null, // Since there's no getTypes for CasesAPI
  },
  {
    id: CUSTOM_FIELD_CATEGORIES.EVIDENCE,
    description:
      "Create custom fields for evidence items. These custom fields will appear when creating new evidence items and will also show as a column in the evidence grid. You can associate custom fields with a specific evidence type so that it is only available when that evidence type is selected.",
    createField: CustomFieldsApi.createCustomField,
    updateField: CustomFieldsApi.updateCustomField,
    deleteField: CustomFieldsApi.deleteCustomField,
    getFields: CustomFieldsApi.getCustomFields,
    getTypes: EvidenceTypesAPI.getEvidenceTypes,
  },
  {
    id: CUSTOM_FIELD_CATEGORIES.INQUIRY,
    description:
      "Create custom fields for inquiries. These custom fields will appear when creating new inquiries and will also show as a column in the inquiry grid.",
    createField: CustomFieldsApi.createCustomField,
    updateField: CustomFieldsApi.updateCustomField,
    deleteField: CustomFieldsApi.deleteCustomField,
    getFields: CustomFieldsApi.getCustomFields,
    getTypes: null, // Since there's no getTypes for InquiriesAPI
  },
  {
    id: CUSTOM_FIELD_CATEGORIES.ACQUISITION,
    description:
      "Create custom fields for acquisition items. These custom fields will appear when creating new acquisition items and will also show as a column in the acquisition grid.",
    createField: CustomFieldsApi.createCustomField,
    updateField: CustomFieldsApi.updateCustomField,
    deleteField: CustomFieldsApi.deleteCustomField,
    getFields: CustomFieldsApi.getCustomFields,
    getTypes: null, // Since there's no getTypes for AcquisitionsAPI
  },
  {
    id: CUSTOM_FIELD_CATEGORIES.STORAGE,
    description:
      "Create custom fields for storage. These custom fields will appear when creating new storage and will also show as a column in the storage grid.",
    createField: CustomFieldsApi.createCustomField,
    updateField: CustomFieldsApi.updateCustomField,
    deleteField: CustomFieldsApi.deleteCustomField,
    getFields: CustomFieldsApi.getCustomFields,
    getTypes: null, // Since there's no getTypes for CaseStorageAPI
  },
  {
    id: CUSTOM_FIELD_CATEGORIES.PEOPLE,
    description:
      "Create custom fields for people. These custom fields will appear for both clients and contacts.",
    createField: CustomFieldsApi.createCustomField,
    updateField: CustomFieldsApi.updateCustomField,
    deleteField: CustomFieldsApi.deleteCustomField,
    getFields: CustomFieldsApi.getCustomFields,
    getTypes: null, // Since there's no getTypes for CaseStorageAPI
  },
];

export default customFieldAPIBundler;
